// extracted by mini-css-extract-plugin
export var brand = "_redotech-redo-web-src-button-brand";
export var button = "_redotech-redo-web-src-button-button";
export var chevron = "_redotech-redo-web-src-button-chevron";
export var chevronButton = "_redotech-redo-web-src-button-chevron-button";
export var content = "_redotech-redo-web-src-button-content";
export var danger = "_redotech-redo-web-src-button-danger";
export var dark = "_redotech-redo-web-src-button-dark";
export var ghost = "_redotech-redo-web-src-button-ghost";
export var gray = "_redotech-redo-web-src-button-gray";
export var icon = "_redotech-redo-web-src-button-icon";
export var iconButton = "_redotech-redo-web-src-button-icon-button";
export var light = "_redotech-redo-web-src-button-light";
export var medium = "_redotech-redo-web-src-button-medium";
export var micro = "_redotech-redo-web-src-button-micro";
export var outlined = "_redotech-redo-web-src-button-outlined";
export var pending = "_redotech-redo-web-src-button-pending";
export var primary = "_redotech-redo-web-src-button-primary";
export var small = "_redotech-redo-web-src-button-small";
export var solidLight = "_redotech-redo-web-src-button-solid-light";
export var solidLightBrand = "_redotech-redo-web-src-button-solid-light-brand";
export var spinner = "_redotech-redo-web-src-button-spinner";